export default __webpack_public_path__ + "fk-cp-zion/img/empty-wishlist-illustration_0f2661.jpg";